import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
// import { CustomerGetAction, CustomerStatusAction } from '../../Redux/Action/CustomerAction';
import { CategoryAddAction, CategoryGetAction } from "../../Redux/Action/Category";
import { toast } from "react-toastify";
import { imageExtentionSupport } from "../../utils/Helper";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { AtributeCrateaAction } from "../../Redux/Action/AtributeAction";
import { FormattedMessage, useIntl } from "react-intl";



interface FormInputs {
  title: string,
  attrib_type: string,

}
function AttribsManagementAdd() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const intl = useIntl();
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const atributesstatus  = useSelector((state:any)=>state.AtributeCreateState)
  const [loading , setLoading] = useState(false)

  const formSchema: any = Yup.object().shape({
    title: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_title" }))
      .trim()
      .min(2, intl.formatMessage({ id: "title_min_length" }))
      .max(255, intl.formatMessage({ id: "title_max_length" })),

      attrib_type: Yup.string()
      .required(intl.formatMessage({ id: "please_enter_attribute_type" }))
      .trim()
  });
  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });
  const onSubmit = (data: FormInputs) => {
    setLoading(true)
    dispatch(AtributeCrateaAction(data))
  };
  useEffect(()=>{
  if(atributesstatus.status){
    setTimeout(() => {
      navigate("/atribute-list")
    }, 1000);
  }
  },[atributesstatus])

  useEffect(() => {
        return () => {
            dispatch(AtributeCrateaAction('RESET'));
        }
  }, [])
  return (
    <Fragment>
      {log_in?.loading || loading ? <Spinner /> : ""}
      <PageLayout
        title={<FormattedMessage id="block_reason_add" />}
        breadcrumbs={{
          secLast: { 'link': '/atribute-list', 'name': <FormattedMessage id="block_reason" /> },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >


        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label"><FormattedMessage id="title" /></label>
                <input type="text" className="form-control mb-0" id="title" placeholder={intl.formatMessage({ id: "enter_title" })} {...register("title", {
                  required: intl.formatMessage({ id: "please_enter_title" }),

                })}
                  onInput={(e: any) => {
                    // e.target.value = e.target.value.replace(/\s/g, '');
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="title"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="attrib_type" className="form-label"><FormattedMessage id="attribute_type" /></label>
                <select
                  id="attrib_type"
                  className="form-control profile-approve-dropdown"
                  {...register("attrib_type", {
                    required: intl.formatMessage({ id: "please_select_attribute_type" })
                  })}
                >
                  <option value="">{intl.formatMessage({ id: "select_type" })}</option>
                  <option value="1">{intl.formatMessage({ id: "reason" })}</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="attrib_type"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2 col-sm-6 col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100"><FormattedMessage id="save" /></button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default AttribsManagementAdd